export const posologyTypes = {
	allDays: 1,
	dayYesDayNot: 2,
	weekly: 3,
	monthly: 4,
	other: 5,
	dayNotDayYes: 6
};
